module.exports = __webpack_public_path__ + "static/media/APPSTORE.ce0c2774.png";